/**
 * Share buttons displayed on the article page.
 * On mobile/tablet: they are displayed in an overlay after a click on sticky share button.
 * They are also present right after main picture
 *
 * On desktop: they are sticky and displayed on the left of the page.
 */

import _ from "lodash";
import { fbButton, tw, pinterest, linkedin } from 'vanilla-sharing';
import MediaQueries from "../utils/MediaQueries";
import BrowserDetect from "../utils/BrowserDetect";
import Notification from "../notification/Notification";
import I18n from "../i18n/Translation";
// Import sticky-js library (because sticky polyfill is totally messing with Firefox and jquery-sticky seems to not be working in this particular case)
import Sticky from "sticky-js";

let fullWidthElements;
const COLLISION_DELTA = 100; // Delta value to have a smoother animation when detecting a collision
const ARTICLE_SCROLL_DELTA = 40; // Delta value to detect when article intro (picture) has been scrolled

export default {

    init(shareId, forceUrl) {
        let facebookButton = $(`.${shareId}__button--facebook`),
            twitterButton = $(`.${shareId}__button--twitter`),
            pinterestButton = $(`.${shareId}__button--pinterest`),
            linkedinButton = $(`.${shareId}__button--linkedin`),
            copyLinkButton = $(`.${shareId}__button--copy-link`),
            printButton = $(`.${shareId}__button--print`),
            iOsShareButton = $(`.${shareId}__button__ios-share`),
            androidShareButton = $(`.${shareId}__button__android-share`);
        if(forceUrl) {
            const urlMeta = document.querySelector(`meta[property='og:url']`);
            urlMeta.setAttribute("content", forceUrl)

        }
        let url = forceUrl || window.location.href;

        $(facebookButton).click(() => {
            fbButton({ url: url })
        });

        $(twitterButton).click(() => {
            tw({
                url: url,
                title: twitterButton.attr("data-text") + " @" + twitterButton.attr("data-via")
            })
        });

        $(pinterestButton).click(() => {
            pinterest({ url: url })
        });

        $(linkedinButton).click(() => {
            linkedin({ url: url })
        });

        this.enableCopyLink(copyLinkButton, url);
        this.enablePrint(printButton);
        this.displayNativeShareButton(iOsShareButton, androidShareButton);
    },

    initWithParameter(shareId, name, value) {
        this.init(shareId, window.location.href + "?" + name + "=" + value)
    },

    _hasEnoughScroll() {
        return $(window).scrollTop() >= $(".container").offset().top + ARTICLE_SCROLL_DELTA;
    },

    _isCollidedWithElement(shareId) {
        let shareButtons = $(`.${shareId}`);

        // Filter all elements in the article that can overlap on comment buttons
        // They should be visible and be positioned on the left of the page
        if(!fullWidthElements) {
            let articlePageContentChild = $(`.article-page-content > *:not(.${shareId})`);

            fullWidthElements = articlePageContentChild.filter(function (i, el) {
                let computedStyle = window.getComputedStyle(el);
                return computedStyle.display !== "none"
                    && computedStyle.visibility !== "hidden"
                    && $(this).offset().left <= shareButtons.offset().left + shareButtons.width();
            });
        }

        return _.reduce(fullWidthElements, function(shouldHideAcc, element) {
            let fullWidthElement = $(element);

            // Determine if share buttons are in collision with an element by comparing top positions
            return shouldHideAcc || (
                shareButtons.offset().top < fullWidthElement.offset().top + fullWidthElement.innerHeight() + COLLISION_DELTA &&
                shareButtons.innerHeight() + shareButtons.offset().top + COLLISION_DELTA > fullWidthElement.offset().top
            );
        }, false);
    },

    initScroll(shareId) {

        let shareButtons = $(`.${shareId}`),
            stickyShareButtons;

        let handleScroll = () => {
            if(this._shouldDisableSticky())
                return;

            if(!this._hasEnoughScroll() || this._isCollidedWithElement(shareId)) {
                shareButtons.removeClass("share-buttons--visible");
            } else {
                shareButtons.addClass("share-buttons--visible");
            }
        };

        // We want to show/hide floating share buttons only on desktop
        stickyShareButtons = this._updateSticky(stickyShareButtons, shareId);

        const throttledHandleScroll = () => requestAnimationFrame(handleScroll);
        $(window).scroll( _.throttle(throttledHandleScroll, 100));

        $(window).resize(() => {
            stickyShareButtons = this._updateSticky(stickyShareButtons, shareId);
        });
    },

    enableCopyLink(button, url) {
        button.click(function () {

            let $temp = $("<input>");
            $("body").append($temp);

            // to copy anchor link of a chapter in a Storytelling article
            let chapterAnchorLink = $(this).attr("data-chapter-anchor");
            if(chapterAnchorLink) {
                $temp.val(chapterAnchorLink);
            } else {
                $temp.val(url);
            }

            // handle iOS as a special case
            if (BrowserDetect.isIOS()) {

                // convert to editable with readonly to stop iOS keyboard opening
                $temp[0].contentEditable = true;
                $temp[0].readOnly = true;

                // create a selectable range
                let range = document.createRange();
                range.selectNodeContents($temp[0]);

                // select the range
                let selection = window.getSelection();
                selection.removeAllRanges();
                selection.addRange(range);
                $temp[0].setSelectionRange(0, 999999);
            }
            else {
                $temp.select();
            }

            document.execCommand("copy");
            $temp.remove();

            // Show feedback to the user
            Notification.show(I18n.translate("share-buttons.copy-to-clipboard-message"));
        })
    },

    enablePrint(button) {
        button.click(function () {
            if(window.print) {
                window.print();
            }
        });
    },

    displayNativeShareButton(iOsShareButton, androidShareButton) {
        if(BrowserDetect.isIOS()) {
            iOsShareButton.removeClass("u-hide");
        } else {
            androidShareButton.removeClass("u-hide");
        }
    },

    _updateSticky(stickyShareButtons, shareId) {
        if(this._shouldDisableSticky()) {
            if(stickyShareButtons) {
                $(`.${shareId}`).attr("style", "");
                stickyShareButtons.destroy();
            }

            return undefined;
        } else if(stickyShareButtons) {
            return stickyShareButtons;
        } else {
            const marginTop = $("body.unsubscribed").length ? 175 : 120;
            return new Sticky(`.${shareId}`, {
                marginTop,
                stickyContainer: `.${shareId}`
            });
        }
    },

    _shouldDisableSticky() {
        return !MediaQueries.isLgUp() || MediaQueries.isPortrait();
    }
};



// WEBPACK FOOTER //
// ./js/social/ShareButtons.js